var inlineSelect = function(selectID,config={}){
  this.selectID = selectID;
  this.select = document.getElementById(selectID);
  this.config = {
    optionHeight:70,
    ...config
  };
  this.lastScroll = -1;

  this.layout();
  this.position();
  this.selectOption();
  this.events();
}

inlineSelect.prototype.layout = function(){



  this.select.style.display = "none";

  this.selectHolder = document.createElement("div");
  this.selectHolder.classList.add("inlineSelect");

  this.lineTop = document.createElement("div");
  this.lineTop.classList.add("lineTop");

  this.lineBottom = document.createElement("div");
  this.lineBottom.classList.add("lineBottom");

  this.selectHolder.append(this.lineTop);
  this.selectHolder.append(this.lineBottom);

  this.selectValue = document.createElement("div");
  this.selectValue.classList.add("value");
  this.selectValue.style.height = this.config.optionHeight+"px";




  this.selectOptionHolder = document.createElement("div");
  this.selectOptionHolder.classList.add("optionHolder");

  this.selectArrowDown = document.createElement("div");
  this.selectArrowDown.classList.add("arrowDown");
  this.selectArrowDown.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Caret Down</title><path d="M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"/></svg>';

  this.selectArrowUp = document.createElement("div");
  this.selectArrowUp.classList.add("arrowUp");
  this.selectArrowUp.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Caret Up</title><path d="M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"/></svg>';

  this.selectHolder.append(this.selectArrowDown);
  this.selectHolder.append(this.selectArrowUp);

  this.selectHolderBlur = document.createElement("div");
  this.selectHolderBlur.classList.add("inlineSelectBlur");

  this.selectHolder.append(this.selectValue);
  this.selectHolder.append(this.selectOptionHolder);
  this.selectHolder.append(this.selectHolderBlur);

  this.selectOptions = [];
  for(let i = 0;i<this.select.options.length;i++){
    var o = this.select.options[i];


    this.selectOptions[i] = document.createElement("div");
    this.selectOptions[i].classList.add("option");
    this.selectOptions[i].innerText = o.innerText;
    this.selectOptions[i].style.height = this.config.optionHeight+"px";
    this.selectOptions[i].setAttribute("data-value",o.value);
    this.selectOptions[i].setAttribute("data-index",i);

    this.selectOptions[i].addEventListener("click",(e)=>{
      e.preventDefault();
      this.selectOption(e.currentTarget.getAttribute("data-index"));
      setTimeout(()=>{
        this.hide();
      },200);
    });

    this.selectOptionHolder.append(this.selectOptions[i]);
  }



  this.select.parentNode.insertBefore(this.selectHolder,this.select);




}

inlineSelect.prototype.show = function(){
  var otherElements = document.querySelectorAll(".inlineSelect");
  otherElements.forEach(e=>{
    e.classList.remove("show");
  });
  this.expanded = true;
  if(this.selectOptionHolder.scrollTop > this.optionHolderHeight - this.optionHolderTop){
    this.selectArrowUp.style.display = "block";
  }

  if(this.selectOptionHolder.scrollTop < (this.optionHolderHeight - this.optionHolderTop)+((this.select.options.length-1)*this.config.optionHeight)){
    this.selectArrowDown.style.display = "block";
  }
  this.selectHolder.classList.add("show");
  document.body.style.overflowY = "hidden";

};

inlineSelect.prototype.hide = function(){
  this.expanded = false;
  this.selectHolder.classList.remove("show");
  document.body.style.overflowY = "auto";
  this.selectArrowUp.style.display = "none";
  this.selectArrowDown.style.display = "none";
  if(this.config.onChange){
    this.config.onChange();
  }
};

inlineSelect.prototype.remove = function(){
  this.events(true);


  this.selectHolder.remove();
  this.lineTop.remove();
  this.lineBottom.remove();
  this.selectValue.remove();
  this.selectOptionHolder.remove();
  this.selectHolderBlur.remove();
  this.selectArrowUp.remove();
  this.selectArrowDown.remove();

  this.selectHolder = false;
  this.lineTop = false;
  this.lineBottom = false;
  this.selectValue = false;
  this.selectOptionHolder = false;
  this.selectHolderBlur = false;
  this.selectOptions = false;
  this.selectArrowUp = false;
  this.selectArrowDown = false;



};

inlineSelect.prototype.position = function(){
  var selectPosition = this.selectHolder.getBoundingClientRect();

  this.optionHolderTop = Math.floor(selectPosition.top/this.config.optionHeight)*this.config.optionHeight;

  if(this.optionHolderTop < 150){
    this.optionHolderTop = 150;
  }

  if(this.optionHolderTop > 300){
    this.optionHolderTop = 300;
  }
  this.optionHolderHeight = (this.optionHolderTop * 2) + this.config.optionHeight;

  //this.optionHolderHeight = (this.select.options.length * this.config.optionHeight) > (window.innerHeight*0.6) ? window.innerHeight*0.6  : this.select.options.length * this.config.optionHeight;
  this.selectOptionHolder.style.height = this.optionHolderHeight+"px";
  this.selectOptionHolder.style.top = -this.optionHolderTop+"px";

  this.selectArrowUp.style.top = -this.optionHolderTop+"px";
  this.selectArrowDown.style.top = (this.config.optionHeight-28)+this.optionHolderTop+"px";

  if(!this.scrollSpacer){
    this.scrollSpacer = document.createElement("div");
    this.scrollSpacer.style.height = this.optionHolderHeight + "px";
    this.selectOptionHolder.append(this.scrollSpacer);
    this.selectOptionHolder.prepend(this.scrollSpacer.cloneNode());
  }


};

inlineSelect.prototype.selectOption = function(optionIndex=false){
  if(!this.selectOptionHolder) return;

  if(optionIndex !== false){
    this.select.selectedIndex = parseInt(optionIndex);
    this.select.options[optionIndex].setAttribute("selected","selected");
  }


  var newScroll = this.optionHolderHeight + (this.select.selectedIndex*this.config.optionHeight) - this.optionHolderTop;

  this.selectOptionHolder.scrollTo({top:newScroll,behavior:"auto"});


  this.selectValue.innerText = this.select.options[this.select.selectedIndex].innerText;



}

inlineSelect.prototype.events = function(remove = false){

  this.scrollTimer = false;

  const _selectValueClick = (e) => {
    if(this.selectHolder.classList.contains("show")){
      this.hide();
      this.selectOption();
    }
    else{
      this.show();
      this.selectOption();
    }
  }

  const _arrowUpClick = (e) => {
    var newScroll = this.selectOptionHolder.scrollTop - (Math.floor((this.optionHolderHeight)/this.config.optionHeight)*this.config.optionHeight);
      this.selectOptionHolder.scrollTo({top:newScroll,behavior:"smooth"});
  }

  const _arrowDownClick = (e) => {
    var newScroll = this.selectOptionHolder.scrollTop + (Math.floor((this.optionHolderHeight)/this.config.optionHeight)*this.config.optionHeight);
      this.selectOptionHolder.scrollTo({top:newScroll,behavior:"smooth"});
  }

  const _selectHolderBlurClick = (e) => {
    this.hide();
  }

  const _windowResizeEvent = () => {
    this.position();
  }

  const _selectOptionScroll = (e) =>{
    if(this.expanded){
      this.selectArrowUp.style.display = "block";
      this.selectArrowDown.style.display = "block";
    }
    if(e.currentTarget.scrollTop <= this.optionHolderHeight - this.optionHolderTop){
      this.selectOptionHolder.scrollTo({top:this.optionHolderHeight - this.optionHolderTop,behavior:"auto"});
      this.selectArrowUp.style.display = "none";
    } else if(e.currentTarget.scrollTop >= (this.optionHolderHeight - this.optionHolderTop)+((this.select.options.length-1)*this.config.optionHeight)){
      this.selectOptionHolder.scrollTo({top:(this.optionHolderHeight - this.optionHolderTop)+((this.select.options.length-1)*this.config.optionHeight),behavior:"auto"});
      this.selectArrowDown.style.display = "none";

    }

    if(this.scrollTimer){
      clearTimeout(this.scrollTimer)
    }

    this.selectedOption = Math.round((this.selectOptionHolder.scrollTop)/this.config.optionHeight);
    this.selectedOption += Math.round((this.optionHolderTop-this.optionHolderHeight)/this.config.optionHeight);

    var blurOption = this.selectOptionHolder.querySelector(".selected");
    if(blurOption){
      blurOption.classList.remove("selected");
    }
    if(this.selectOptions[this.selectedOption]){
      this.selectOptions[this.selectedOption].classList.add("selected");
    }


    this.scrollTimer = setTimeout(()=>{
      clearTimeout(this.scrollTimer);
      // SCROLL ENDED
      if(this.selectedOption < 0){
        e.preventDefault();
        this.selectedOption = 0;

      }
      else if(this.selectedOption >= this.select.options.length){
        e.preventDefault();
        this.selectedOption = this.select.options.length-1;
      }

      this.selectOption(this.selectedOption);




    },150);
  }

  if(remove){
    this.selectValue.removeEventListener("click",_selectValueClick);
    this.selectHolderBlur.removeEventListener("click",_selectHolderBlurClick)
    window.removeEventListener("resize",_windowResizeEvent);
    this.selectOptionHolder.removeEventListener("scroll",_selectOptionScroll);
    this.selectArrowUp.removeEventListener("click",_arrowUpClick);
    this.selectArrowDown.removeEventListener("click",_arrowDownClick);

  }
  else{
    this.selectArrowUp.addEventListener("click",_arrowUpClick);
    this.selectArrowDown.addEventListener("click",_arrowDownClick);

    this.selectValue.addEventListener("click",_selectValueClick);
    this.selectHolderBlur.addEventListener("click",_selectHolderBlurClick)
    window.addEventListener("resize",_windowResizeEvent);
    this.selectOptionHolder.addEventListener("scroll",_selectOptionScroll);
  }


}
